import axios from 'axios'

const instance = axios.create()

instance.interceptors.request.use(config => {
  console.log(new Date(), '[Request Axios]', config.url)
  return config
}, (error) => {
  return Promise.reject(error)
})

instance.interceptors.response.use((response) => {
  console.log(new Date(), '[Response Axios]', response)
  return response
}, (error) => {
  return Promise.reject(error)
})

export default instance
